exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media (min-width: 768px) {\n.users-search[data-v-06c71629] {\r\n    width: 400px;\n}\n}\r\n", ""]);

// exports
